import FacturasProvider from "./FacturasProvider"
import FacturasLista from "./FacturasLista"
import FacturasDialogEstado from "./FacturasDialogEstado"

const Facturas = () => {
  return (
    <FacturasProvider>
      <FacturasDialogEstado />
      <FacturasLista />
    </FacturasProvider>
  )
}

export default Facturas
